import { Link } from "@reach/router";
import React, { ReactElement }from "react";

interface AuthorArticleProps {
    image: {
        url: string,
        alt?: string,
    },
    title: string,
    summary: string,
    redirectTo: string,
}

const AuthorArticle : React.FC<AuthorArticleProps> = ({ image, title, summary, redirectTo }) : ReactElement => {
    return (
        <Link to={redirectTo} className="w-full flex flex-row items-center px-[0.8rem] mb-[1rem]">
            <div className="aspect-square">
                <div className="w-[85px] h-[85px] rounded-[0.625rem] overflow-hidden">
                    <img src={image.url} className="h-full object-cover" alt={image.alt} loading="lazy" />
                </div>
            </div>
            <div className="grow pr-2 pl-3 flex flex-row items-center">
                <div className="w-full h-fit text-deep-blue">
                    <p className="subtitle-3 line-clamp-1">
                        {title}
                    </p>
                    <p className="font-ibmPlexSansSemiBold text-mobile-caption md:text-desktop-caption line-clamp-3">
                        {summary}
                    </p>
                </div>
            </div>
        </Link>
    );
}

export default AuthorArticle;
